import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const List = styled.ul`
    ${styledReset.list}
`;

export const Item = styled.li`
    & + & {
        border-top: 1px solid ${(props) => props.theme.shades.white['20']};
    }
`;
